module.exports = __webpack_public_path__ + "assets/img/aboutUS-module4-1.727aa113.jpg";